/* ****************************************************************************
 DEPRECATED USE FUNCTION formatNum INSTEAD, THERE IS A PROBLEM ON REFRESH DATA 
 **************************************************************************** */
import { AfterViewInit, Directive, ElementRef, Input } from "@angular/core";
import { formatNum } from "../utils/number.util";

@Directive({
    selector: "[format-number]"
})
export class FormatNumberDirective implements AfterViewInit {

    constructor(
        private elementRef: ElementRef
    ) { }
    ngAfterViewInit(): void {
        const htmlElement = this.elementRef.nativeElement as HTMLElement;
        // let textContent = htmlElement.textContent.replaceAll(' ', '');
        htmlElement.textContent = formatNum(parseFloat(htmlElement.textContent));
    }

}